module.exports = __webpack_public_path__ + "static/media/Baskerville.ff60b968.svg";